/**
 * 获取微信版本号
 * @return [String] xx.x.x
 */
export function getWXVersion() {
  const version = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i)
  if (version) {
    return version[1]
  } else {
    return false
  }
}
/**
 * 获取ios版本号
 * @return [String] xx.x.x
 */
export function getIOSVersion() {
  const ua = navigator.userAgent.toLowerCase()
  const version = ua.match(/cpu iphone os (.*?) like mac os/)
  if (version) {
    return version[1].replace(/_/g, '.')
  } else {
    return false
  }
}
/**
 * 获取安卓版本号
 * @return [String] 有的直接例如返回10，没有xx.x.x这些
 */
export function getAndroidVersion() {
  const ua = navigator.userAgent.toLowerCase()
  const version = ua.match(/android\s([0-9\.]*)/)
  if (version) {
    return version[1]
  } else {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/public-resource/libs/version/index.js